export const Resume = () => {
    return (
        window.location.replace("/resume.html")
    )
}